class SessionExpirationModalController {
  constructor($scope, $uibModalInstance, $interval) {
      "ngInject";
      this.name = 'SessionExpirationModal';
      $scope.title = $uibModalInstance.title;
      $scope.subject = $uibModalInstance.subject;
      $scope.message = $uibModalInstance.message;

      $interval(function(){
        $scope.countdown = $uibModalInstance.countdown;
      },60);

      $scope.extendSession = function () {
        $uibModalInstance.extendSession();
      };

  }

}

export default SessionExpirationModalController;



// WEBPACK FOOTER //
// ./client/common/modals/sessionExpirationModal/sessionExpirationModal.controller.js